import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AuthContext } from "../../../services/auth";
import ApiService from "../../../services/api";


const Portfolio = () => {
    const { isEnglish } = useContext(AuthContext);

    const [portfolio, setPortfolio] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const fetchPortfolio = async () => {
        try {
            const portfolioList = await ApiService.getPortfolio();
            const categories = Array.from(
                new Map(
                    portfolioList.map(item => [item.category, { category: item.category, category_eng: item.category_eng }])
                ).values()
            );
            setPortfolio(portfolioList);
            setCategories(categories);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching portfolio:", error);
        }
    }

    useEffect(() => {
        fetchPortfolio();
    }, []);

    if (isLoading) return <></>;
    return (
        <Container className="p-0 m-0 " fluid>
            <Container className="padding_custom">
                <Row className="px-2">
                    <Col>
                        <h3 className="text-center w-100 section-title mt-5">
                            {isEnglish ? "PORTFOLIO" : "PORTFOLIO"}
                        </h3>
                        <div className="border-custom mt-3 "></div>
                        {categories.map((category, index) => (
                            <div key={index} className="mb-5">
                                <h3 className="py-4 pt-5 text-center section-subtitle">
                                    {isEnglish ? category.category_eng : category.category}
                                </h3>
                                {portfolio
                                    .filter(item => item.category === category.category)
                                    .map((item, subIndex) => (
                                        <h5 key={subIndex} className="section-text text-center mb-3">
                                            {isEnglish ? item.title_eng : item.title}
                                        </h5>
                                    ))}
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};
export default Portfolio;
